<template>
  <div class="flex">
    <el-col :span="8" v-loading="trailsinfoReqStatus === 'loading' && localFetchTrailStatus === 'loading'">
      <el-row class="list-summary">
        <el-col :span="12">
          <span class="body2" v-if="!filterdPostureList.length">None</span>
          <span class="body2" v-if="filterdPostureList.length > 0">{{
            `1-${filterdPostureList.length} of ${filterdPostureList.length}`
          }}</span>
        </el-col>
        <el-col :span="12">
          <span class="body2 float-right">
            <el-select
              v-model="sortSel"
              @change="sortList(sortSel)"
              placeholder="Select"
              class="body2"
              style="max-width: 100px"
            >
              <el-option v-for="item in sortOptions" :key="item.value" :label="item.label" :value="item.value">
                <span class="body2">{{ item.label }}</span>
              </el-option>
            </el-select>
          </span>
        </el-col>
      </el-row>
      <el-row class="c-table">
        <div
          v-if="trailInfoLoaded"
          v-infinite-scroll="load"
          infinite-scroll-disabled="disabled"
          infinite-scroll-distance="10"
          style="overflow:auto;"
          id="trailvlist"
          :key="trailvlistKey"
        >
          <div
            style="max-height: '65px'; padding: '2px 0px';"
            class="c-table_row trail-list"
            :class="{ active: filteredTrailsList[val].selected }"
            v-for="(val, idx) in range(0, trailCount)"
            :key="filteredTrailsList[val].trailIdHash"
          >
            <trail-info-card
              parent=".trail-list"
              :trail="filteredTrailsList[val]"
              @card-click="highlightNode(filteredTrailsList[val], $event)"
              @select-previous="showHostpathTooltip"
              @select-next="showHostpathTooltip"
              @select-close="hideHostpathTooltip"
            />
          </div>
        </div>
      </el-row>
      <footer>
        <router-link to="/monitor/cyber-attacks/active" class="float-right cursor-pointer">
          <span class="box text-button uppercase">view all -></span>
        </router-link>
      </footer>
    </el-col>
    <el-col :span="16" class="scrollable only-y" v-if="networkHostsReqStatus === 'saved'">
      <d3-force-directed
        ref="agentNetwork"
        :nodes="networkHosts.nodes"
        :links="networkHosts.links"
        :options="networkHosts.options"
      ></d3-force-directed>
    </el-col>
  </div>
</template>

<script>
import { destroyInverval } from '@/utilities/global.interval'
import { mapGetters } from 'vuex'
import { removalsFromArray, insertsIntoArray } from '@/utilities/collection.helper'
import {
  TRAILSINFO_LIST_REQUEST,
  TRAILSINFO_LIST_SUCCESS,
  TRAILSINFO_LIST_STATUS_RESET
} from '@/store/modules/trails/trailsinfo.type'
import { AGENT_LIST_REQ } from '@/store/modules/agents/agents.type'
import { TRAIL_DASHBOARD_USER_PREF } from '@/store/modules/user_pref/user-pref.type'
import DonutChartJs from '@/components/chart/DonutChartJs.vue'
import LineChartJs from '@/components/chart/LineChartJs.vue'
import D3ForceDirected from '@/components/network-graph/D3ForceDirected.vue'
import TrailInfoCard from '@/components/card/TrailInfoCard.vue'

import agentListInfoMixin from '@/mixins/agentInfoMixin'
import trailListInfoMixin from '@/mixins/trailInfoMixin'

export default {
  name: 'TrailSecurityPostureDashboard',
  data () {
    return {
      trail: {},
      selectedPostureInfoList: {},
      localFetchTrailStatus: 'loading',
      trailsIntervalId: {},
      sortOptions: [
        {
          value: 'desc_score',
          label: 'Highest'
        },
        {
          value: 'asc_score',
          label: 'Lowest'
        },
        {
          value: 'desc_datetime',
          label: 'Latest'
        },
        {
          value: 'asc_datetime',
          label: 'Oldest'
        }
      ],
      filterdPostureList: [],
      trailCount: 0,
      trailInfoLoaded: false,
      filteredTrailsList: [],
      trailvlistKey: 0 // key used to re-render trails list
    }
  },
  mixins: [agentListInfoMixin, trailListInfoMixin],
  mounted () {
    // window resize event
    let debounceResize = _.debounce(this.forceRerenderList, 500)

    window.addEventListener('resize', debounceResize)
  },
  created () {
    // initial load, call backend for trail and agent info records
    // subsequent loads should take from cached list first and refresh after
    if (
      this.trailsinfoReqStatus === 'saved' &&
      this.agentListReqStatus === 'saved' &&
      this.lateralMovementReqStatus === 'saved'
    ) {
      this.mapAgentLinks(this.agentList, this.uniqComboLateralMovements)

      this.$nextTick(function () {
        this.$set(this, 'selectedPostureInfoList', this.trailsinfoRecords.models)
        this.$set(this, 'localFetchTrailStatus', 'saved')
        this.filterTrailList()

        if (_.isEmpty(this.trailsIntervalId)) {
          this.updateTrailAndAgent()
        }
        this.trailInfoLoaded = true
        this.setListHeight()
      })
    } else {
      this.getTrailListInfo()
    }
  },
  methods: {
    resetFilteredTrailsListData () {
      this.filteredTrailsList = []
      this.trailCount = 0
      this.trailInfoLoaded = true
    },
    sortList (sortSel) {
      this.sortTrailList(sortSel)
      if (!_.isEmpty(this.$route.query)) {
        this.filterTrailList()
      } else {
        this.filterdPostureList = _.cloneDeep(this.selectedPostureInfoList)
      }
      this.resetFilteredTrailsListData()
      this.forceRerenderList()
    },
    forceRerenderList () {
      this.trailvlistKey += 1
      this.setListHeight()
    },
    setListHeight () {
      setTimeout(() => {
        const listElement = document.getElementById('trailvlist')
        const listHeight = this.$parent.$el.clientHeight - 96
        listElement.style.height = `${listHeight}px`
      })
    },
    range (start, end) {
      let rangeArr = []
      for (let i = start; i < end; i++) {
        rangeArr.push(i)
      }
      return rangeArr
    },
    load () {
      this.filteredTrailsList.push(this.filterdPostureList[this.trailCount])
      this.trailCount += 1
    },
    showHostpathTooltip (sel) {
      this.showAgentTooltip({
        agentId: sel.trail.hostTimeInfoMap[sel.hostIndex].host
      })
    },
    hideHostpathTooltip (ev) {
      this.hideAgentTooltip({}, ev)
    },
    filterTrailList () {
      this.filterdPostureList = []
      if (!_.isEmpty(this.$route.query)) {
        let newAssignee = this.$route.query.assignee
        if (!_.isArray(newAssignee)) {
          newAssignee = [newAssignee]
        }

        // if no filter, set all to visible
        if (_.isEmpty(newAssignee)) {
          this.filterdPostureList = _.cloneDeep(this.selectedPostureInfoList)
          return
        }

        for (let trailInfo of this.selectedPostureInfoList) {
          // if unassigned only
          if (newAssignee.length === 1 && _.indexOf(newAssignee, 'unassigned') > -1) {
            if (!trailInfo.workHistory) {
              this.filterdPostureList.push(trailInfo)
            }
          } else if (newAssignee.length > 1 && _.indexOf(newAssignee, 'unassigned') > -1) {
            if (!trailInfo.workHistory || _.indexOf(newAssignee, trailInfo.ownerId.email) > -1) {
              this.filterdPostureList.push(trailInfo)
            }
          } else {
            if (trailInfo.workHistory) {
              // check if trail is assigned to user(s)
              if (_.indexOf(newAssignee, trailInfo.ownerId.email) >= 0) {
                this.filterdPostureList.push(trailInfo)
              }
            }
          }
        }
      } else {
        this.filterdPostureList = _.cloneDeep(this.selectedPostureInfoList)
      }
    },
    // override mixin method
    getAgentListInfo (ignoreScore = false) {
      this.$store.dispatch(AGENT_LIST_REQ).then(agents => {
        // remove all lateral movements not pertaining to attack trails
        agents.models.sort((a, b) => {
          return a.agentId - b.agentId
        })
        this.mapAgentLinks(agents.models, this.uniqComboLateralMovements, ignoreScore)

        // set up polling
        if (_.isEmpty(this.trailsIntervalId)) {
          this.updateTrailAndAgent()
        }
      })
    },
    // override mixin method
    updateAgentInfo (ignoreScore = false) {
      this.$store.dispatch(AGENT_LIST_REQ).then(agents => {
        this.mapUpdatedAgentInfo(agents.models, this.uniqComboLateralMovements, ignoreScore)
      })
    },
    getTrailListInfo () {
      this.$store
        .dispatch(TRAILSINFO_LIST_REQUEST, {
          state: 'ACTIVE',
          dateRangeSel: this.dashboardProgressionDateRangeUserSetting
        })
        .then(
          trails => {
            this.$set(this, 'selectedPostureInfoList', trails.models)
            this.$set(this, 'localFetchTrailStatus', 'saved')
            this.sortTrailList(this.sortSel)
            this.filterTrailList()
            this.$store.dispatch(TRAILSINFO_LIST_SUCCESS)

            // need trail list first since to filter out later movements for attack trails
            this.getAgentListInfo()
            this.trailInfoLoaded = true
            this.setListHeight()
          },
          errMsg => {
            console.log(errMsg)
          }
        )
    },
    updateTrailInfo (rerender = false) {
      this.$store
        .dispatch(TRAILSINFO_LIST_REQUEST, {
          state: 'ACTIVE',
          dateRangeSel: this.dashboardProgressionDateRangeUserSetting
        })
        .then(
          trails => {
            this.$store.dispatch(TRAILSINFO_LIST_SUCCESS)

            let prop = this.sortSel.includes('datetime') ? 'startTime' : 'progressionSeverity'
            trails.models.sort((a, b) => {
              if (this.sortSel.includes('desc')) {
                return b[prop] - a[prop]
              }
              return a[prop] - b[prop]
            })

            // silent refresh of trail data
            // 1. track deleted row
            let indexesToBeDeleted = []
            let indexesToBeAdded = []

            this.selectedPostureInfoList.forEach((obj, index) => {
              if (
                !_.some(trails.models, dataObj => {
                  return dataObj.trailIdHash === obj.trailIdHash
                })
              ) {
                indexesToBeDeleted.push(index)
              }
            })
            removalsFromArray(this.selectedPostureInfoList, indexesToBeDeleted)

            // 2. new row
            // 3. existing row, update obj
            trails.models.forEach((trail, index) => {
              let indexFound = _.findIndex(this.selectedPostureInfoList, dataObj => {
                return dataObj.trailIdHash === trail.trailIdHash
              })
              if (indexFound < 0) {
                indexesToBeAdded.push({
                  index: index,
                  newObject: trail
                })
              } else {
                // only update visible properties -> avoids whole card from rerendering
                this.$set(
                  this.selectedPostureInfoList,
                  indexFound,
                  _.assignIn(this.selectedPostureInfoList[indexFound], {
                    riskScore: trail.riskScore,
                    killChainData: trail.killChainData,
                    riskLevel: trail.riskLevel,
                    riskScoreHistory: trail.riskScoreHistory
                  })
                )
              }
            })
            insertsIntoArray(this.selectedPostureInfoList, indexesToBeAdded)
            this.filterTrailList()
            this.updateTrailAndAgent()
            this.trailInfoLoaded = true
            if (rerender) {
              this.forceRerenderList()
            }
          },
          errMsg => {
            console.log(errMsg)
          }
        )
    },
    unselectOutsideTrails (row) {
      this.filteredTrailsList.forEach((trail, idx) => {
        if (trail.trailIdHash !== row.trailIdHash) {
          this.$set(this.filteredTrailsList[idx], 'selected', false)
        }
      })
    }
  },
  computed: {
    ...mapGetters([
      'trailsinfoReqStatus',
      'trailsinfoRecords',
      'agentListReqStatus',
      'agentList',
      'trailSummaryStatus',
      'uniqComboLateralMovements',
      'trailsDashboardUserSetting',
      'dashboardProgressionDateRangeUserSetting'
    ]),
    sortSel: {
      get: function () {
        if (this.trailsDashboardUserSetting) {
          return this.trailsDashboardUserSetting.orderBy
        }
        return 'desc_score'
      },
      set: function (sortSel) {
        this.$store.dispatch(TRAIL_DASHBOARD_USER_PREF, { orderBy: sortSel })
      }
    },
    disabled () {
      return this.trailCount >= this.filterdPostureList.length
    }
  },
  components: {
    DonutChartJs,
    LineChartJs,
    D3ForceDirected,
    TrailInfoCard
  },
  watch: {
    '$route.query.assignee': function (newAssignee, oldAssignee) {
      if (newAssignee !== oldAssignee) {
        this.filterTrailList()
        this.resetFilteredTrailsListData()
        this.forceRerenderList()
      }
    },
    dashboardProgressionDateRangeUserSetting: {
      handler: function (newDateRange, oldDateRange) {
        if (newDateRange !== oldDateRange) {
          this.selectedPostureInfoList.length = 0
          this.filterdPostureList.length = 0
          this.filteredTrailsList.length = 0
          this.trailCount = 0
          this.trailInfoLoaded = false
          this.$nextTick(() => {
            this.updateTrailInfo(true)
          })
        }
      }
    }
  },
  beforeDestroy () {
    // use empty function to kill interval update calls (timing insurance)
    this.updateTrailAndAgent = function () {}
    this.updateTrailAndAgent()
    // kill interval calls
    destroyInverval(this.trailsIntervalId)

    this.$store.dispatch(TRAILSINFO_LIST_STATUS_RESET)
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/global_classes.css';
@import 'assets/styles/text.css';
@import 'assets/styles/colors.css';
@import 'assets/styles/icon.css';

.c-table {
  height: 75%;
  margin-left: 10px;
}

.list-summary {
  .el-col {
    > span {
      margin-left: 16px;
      line-height: 40px;
    }
  }

  /* removal of border around filter dropdown */
  >>> input {
    border: none;
  }
}

.c-table_row {
  border-top: 1px solid var(--border-color);

  &:last-of-type {
    border-bottom: 1px solid var(--border-color);
  }

  &.active {
    width: 98%;
    margin-left: 1%;
    box-shadow: 2px 2px 12px 2px rgba(0, 0, 0, 0.1);
  }
}

footer {
  position: fixed;
  bottom: 10px;
  margin-left: 20%;

  /* remove link decoration of link for 'view all' link */
  a {
    text-decoration: none;
  }

  .text-button {
    padding: 16px 0px;
    color: var(--denim-700);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/TrailsSecurityPostureDashboard.vue